/* Page e-carte cadeau — Numerigram, octobre 2026.
   Habille le formulaire du thème sans le remplacer : le choix du montant pilote la liste
   déroulante du thème, « Pour offrir » coche la case du formulaire destinataire de Shopify,
   et la carte affichée à gauche reprend le montant, le prénom et le message en direct. */
(function () {
  var cfgEl = document.getElementById('sdo-ccad-i18n');
  if (!cfgEl) return;
  var T = {};
  try { T = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var root = cfgEl.closest('product-information') || document.querySelector('product-information');
  if (!root) return;
  root.classList.add('sdo-ccad-page', 'sdo-ccad');
  /* Boutons et visuel montrent la valeur faciale de la carte (nom de la variante),
     le prix réglé dans la devise du visiteur reste affiché par le thème.
     25/10/2026 : une carte par devise. T.devise = devise d'émission de CETTE carte (posée par le Liquid,
     snippets/sdo-carte-cadeau-devise.liquid). La mention « réglée dans votre devise » ne s'affiche que si
     le visiteur paie dans une autre devise : repli sur la carte EUR quand sa devise n'a pas encore de carte. */
  function libelle(valeur) { return String(valeur || '').replace(/\s+/g, ' ').trim(); }
  var DEVISE = T.devise || 'EUR';
  var ACTIVE = (window.Shopify && Shopify.currency && Shopify.currency.active) || DEVISE;
  var MEME = ACTIVE === DEVISE;
  var fmtCarte = null, symbole = DEVISE, symboleAvant = false;
  try {
    fmtCarte = new Intl.NumberFormat(T.locale || 'fr-FR', { style: 'currency', currency: DEVISE, currencyDisplay: 'narrowSymbol', maximumFractionDigits: 0 });
    var parts = fmtCarte.formatToParts(1);
    parts.forEach(function (x) { if (x.type === 'currency') symbole = x.value; });
    symboleAvant = parts.length > 0 && parts[0].type === 'currency';
  } catch (e) { fmtCarte = null; }
  function argent(n) { return fmtCarte ? fmtCarte.format(n) : n + ' ' + DEVISE; }

  var CHIPS = [50, 100, 150, 200, 250, 300, 500];
  var mode = 'moi';
  var dejaDefaut = false;

  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt != null) n.textContent = txt;
    return n;
  }
  /* 25/10/2026 : décimales nulles retirées (« 20,00 $ ») puis séparateurs de milliers (« ¥10,000 », « 5 000 kr ») avant de lire le nombre */
  function nombre(v) { var m = String(v || '').replace(/[.,]00(?!\d)/g, '').replace(/[\s,.\u00a0\u202f']/g, '').match(/\d+/); return m ? parseInt(m[0], 10) : null; }
  function select() { return root.querySelector('variant-selects select'); }
  function champ(sel) { return root.querySelector('recipient-form ' + sel); }

  /* ---------- Visuel ---------- */
  var visuel, montantEl, pourEl, note, noteTexte, noteDate;
  function construireVisuel() {
    var galerie = root.querySelector('media-gallery');
    if (!galerie) return;
    if (visuel && galerie.contains(visuel)) return;
    visuel = el('div', 'sdo-ccad-visuel');
    var carte = el('div', 'sdo-ccad-carte');
    carte.setAttribute('role', 'img');
    var logo = el('img', 'sdo-ccad-carte__logo');
    logo.src = T.logo; logo.alt = ''; logo.width = 400; logo.height = 362;
    pourEl = el('p', 'sdo-ccad-carte__pour');
    var type = el('p', 'sdo-ccad-carte__type', T.type);
    montantEl = el('p', 'sdo-ccad-carte__montant');
    carte.appendChild(logo); carte.appendChild(pourEl); carte.appendChild(type); carte.appendChild(montantEl);
    note = el('div', 'sdo-ccad-note'); note.hidden = true;
    note.appendChild(el('p', 'sdo-ccad-note__titre', T.noteTitre));
    noteTexte = el('p', 'sdo-ccad-note__texte'); note.appendChild(noteTexte);
    noteDate = el('p', 'sdo-ccad-note__date'); note.appendChild(noteDate);
    visuel.appendChild(carte); visuel.appendChild(note);
    galerie.insertBefore(visuel, galerie.firstChild);
    majVisuel();
  }
  function majVisuel() {
    if (!montantEl) return;
    var s = select();
    var val = s ? libelle(s.value) : '';
    if (montantEl.textContent !== val) {
      montantEl.classList.add('est-change');
      setTimeout(function () { montantEl.textContent = val; montantEl.classList.remove('est-change'); }, 120);
    }
    if (!MEME) {
      var pr = root.querySelector('.variant-inline-price');
      if (pr) {
        var vn = pr.parentNode.querySelector('.sdo-ccad-valeur');
        if (!vn) { vn = el('p', 'sdo-ccad-valeur'); pr.parentNode.insertBefore(vn, pr.nextSibling); }
        var tv = T.valeur.replace('{v}', val);
        if (vn.textContent !== tv) vn.textContent = tv;
      }
    }
    var nom = mode === 'offrir' && champ('[name="properties[Recipient name]"]') ? champ('[name="properties[Recipient name]"]').value.trim() : '';
    pourEl.textContent = nom ? T.pour.replace('{nom}', nom) : '';
    var carte = montantEl.parentNode;
    carte.setAttribute('aria-label', T.type + ' ' + val + (nom ? ', ' + pourEl.textContent : ''));
    var msg = mode === 'offrir' && champ('textarea[name="properties[Message]"]') ? champ('textarea[name="properties[Message]"]').value.trim() : '';
    var d = dateInput && mode === 'offrir' ? dateInput.value : '';
    noteTexte.textContent = msg;
    noteDate.textContent = d ? T.envoiLe.replace('{date}', dateLisible(d)) : '';
    note.hidden = !msg && !d;
  }
  function dateLisible(iso) {
    try {
      var p = iso.split('-');
      return new Date(+p[0], +p[1] - 1, +p[2]).toLocaleDateString(T.locale || 'fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return iso; }
  }

  /* ---------- Montants ---------- */
  var grille, btnAutre, libre, libreInput, libreAide, autreOuvert = false, minuLibre = null;
  function optionPour(n) {
    var s = select();
    return s ? [].find.call(s.options, function (o) { return nombre(o.value) === n; }) : null;
  }
  /* 25/10/2026 : bornes et pas du montant libre lus dans les variantes de la carte (et non plus 20 / 500 / 5 en dur) */
  var PLAGE = null;
  function plage() {
    if (PLAGE) return PLAGE;
    var s = select();
    if (!s) return { min: 20, max: 500, pas: 5 };
    var ns = [].map.call(s.options, function (o) { return nombre(o.value); })
      .filter(function (n) { return n; }).sort(function (a, b) { return a - b; });
    if (!ns.length) return { min: 20, max: 500, pas: 5 };
    var pas = 0;
    for (var i = 1; i < ns.length; i++) { var d = ns[i] - ns[i - 1]; if (d > 0 && (!pas || d < pas)) pas = d; }
    PLAGE = { min: ns[0], max: ns[ns.length - 1], pas: pas || 1 };
    return PLAGE;
  }
  function aide() {
    var p = plage();
    return String(T.libreAide || '').replace('{min}', argent(p.min)).replace('{max}', argent(p.max)).replace('{pas}', argent(p.pas));
  }
  function construireMontants() {
    var vs = root.querySelector('variant-selects');
    var s = select();
    if (!vs || !s) return;
    if (grille && document.contains(grille)) { if (!vs.classList.contains('sdo-ccad-cache')) majMontants(); return; }
    var bloc = el('div', 'sdo-ccad-montants');
    bloc.appendChild(el('p', 'sdo-ccad__etape', T.etape1));
    grille = el('div', 'sdo-ccad-montants__grille');
    grille.setAttribute('role', 'group');
    grille.setAttribute('aria-label', T.etape1);
    /* 25/10/2026 : montants ronds de CHIPS ; si la carte n'en a pas assez (ex. yen), 7 montants répartis dans ses variantes */
    var choix = CHIPS.map(optionPour).filter(Boolean);
    if (choix.length < 3) {
      var opts = [].slice.call(s.options), k = Math.min(7, opts.length);
      choix = [];
      for (var j = 0; j < k; j++) {
        var oj = opts[Math.round(j * (opts.length - 1) / Math.max(1, k - 1))];
        if (choix.indexOf(oj) === -1) choix.push(oj);
      }
    }
    choix.forEach(function (o) {
      var b = el('button', 'sdo-ccad-montant', libelle(o.value));
      b.type = 'button';
      b.setAttribute('data-valeur', o.value);
      b.setAttribute('aria-pressed', 'false');
      grille.appendChild(b);
    });
    btnAutre = el('button', 'sdo-ccad-montant sdo-ccad-montant--autre', T.autre);
    btnAutre.type = 'button';
    btnAutre.setAttribute('aria-pressed', 'false');
    btnAutre.setAttribute('aria-expanded', 'false');
    /* 25/10/2026 : carte à quelques montants seulement (tous déjà en boutons) : pas de montant libre */
    if (s.options.length <= choix.length) btnAutre.hidden = true;
    grille.appendChild(btnAutre);
    bloc.appendChild(grille);
    /* Montant libre : arrondi au pas des variantes, entre la plus petite et la plus grande (20 à 500 € par 5 € sur la carte EUR) */
    libre = el('div', 'sdo-ccad-libre'); libre.hidden = true;
    var idL = 'sdo-ccad-libre-' + Math.random().toString(36).slice(2, 7);
    btnAutre.setAttribute('aria-controls', idL); libre.id = idL;
    var lab = el('label', 'sdo-ccad-libre__label', T.libreLabel);
    var champL = el('div', 'sdo-ccad-libre__champ');
    libreInput = el('input');
    libreInput.type = 'text'; libreInput.inputMode = 'numeric'; libreInput.autocomplete = 'off'; libreInput.maxLength = String(plage().max).length;
    libreInput.id = idL + '-in'; lab.setAttribute('for', libreInput.id);
    var devEl = el('span', 'sdo-ccad-libre__devise', symbole);
    if (symboleAvant) { champL.appendChild(devEl); champL.appendChild(libreInput); } else { champL.appendChild(libreInput); champL.appendChild(devEl); }
    libreAide = el('small', 'sdo-ccad-libre__aide', aide());
    libreAide.id = idL + '-aide'; libreInput.setAttribute('aria-describedby', libreAide.id);
    libre.appendChild(lab); libre.appendChild(champL); libre.appendChild(libreAide);
    bloc.appendChild(libre);
    vs.parentNode.insertBefore(bloc, vs);
    vs.classList.add('sdo-ccad-cache');
    grille.addEventListener('click', function (e) {
      var b = e.target.closest('.sdo-ccad-montant');
      if (!b) return;
      if (b === btnAutre) {
        autreOuvert = true;
        var n = nombre(select() && select().value);
        if (n && !libreInput.value) libreInput.value = n;
        majMontants();
        libreInput.focus();
        libreInput.select();
        return;
      }
      autreOuvert = false;
      libreInput.value = '';
      choisir(b.getAttribute('data-valeur'));
    });
    libreInput.addEventListener('input', function () {
      var c = libreInput.value.replace(/\D/g, '').slice(0, libreInput.maxLength);
      if (libreInput.value !== c) libreInput.value = c;
      clearTimeout(minuLibre);
      minuLibre = setTimeout(function () { appliquerLibre(false); }, 600);
    });
    libreInput.addEventListener('blur', function () { appliquerLibre(true); });
    libreInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); appliquerLibre(true); } });
    majMontants();
  }
  function appliquerLibre(final) {
    clearTimeout(minuLibre);
    var n = parseInt(libreInput.value, 10);
    var p = plage();
    if (!n) { libreAide.textContent = aide(); return; }
    if (!final && n < p.min) return;
    var r = Math.min(p.max, Math.max(p.min, p.min + Math.round((n - p.min) / p.pas) * p.pas));
    var o = optionPour(r);
    if (!o) return;
    libreAide.textContent = r !== n ? T.libreArrondi.replace('{v}', libelle(o.value)) : aide();
    if (final) libreInput.value = r;
    choisir(o.value);
  }
  function choisir(valeur) {
    var s = select();
    if (!s || s.value === valeur) { majMontants(); majVisuel(); return; }
    s.value = valeur;
    s.dispatchEvent(new Event('change', { bubbles: true }));
    majMontants();
    majVisuel();
  }
  function majMontants() {
    var s = select();
    if (!grille || !s) return;
    var trouve = false;
    [].forEach.call(grille.querySelectorAll('[data-valeur]'), function (b) {
      if (b.getAttribute('data-valeur') === s.value) trouve = true;
    });
    if (!trouve) autreOuvert = true;
    [].forEach.call(grille.querySelectorAll('[data-valeur]'), function (b) {
      b.setAttribute('aria-pressed', !autreOuvert && b.getAttribute('data-valeur') === s.value ? 'true' : 'false');
    });
    btnAutre.setAttribute('aria-pressed', autreOuvert ? 'true' : 'false');
    btnAutre.setAttribute('aria-expanded', autreOuvert ? 'true' : 'false');
    if (libre) {
      libre.hidden = !autreOuvert;
      if (autreOuvert && !libreInput.value && document.activeElement !== libreInput) libreInput.value = nombre(s.value) || '';
    }
    var vs = root.querySelector('variant-selects');
    if (vs) vs.classList.add('sdo-ccad-cache');
  }

  /* ---------- Pour moi / Pour offrir ---------- */
  var modeBloc, dateInput, dateTexte, dateErreur;
  function bornes() { var a = new Date(); a.setHours(0, 0, 0, 0); var b = new Date(a); b.setDate(b.getDate() + 90); return [a, b]; }
  function fr(d) { return String(d.getDate()).padStart(2, '0') + '/' + String(d.getMonth() + 1).padStart(2, '0') + '/' + d.getFullYear(); }
  function saisirDate() {
    var ch = dateTexte.value.replace(/\D/g, '').slice(0, 8);
    var f = ch.slice(0, 2) + (ch.length > 2 ? '/' + ch.slice(2, 4) : '') + (ch.length > 4 ? '/' + ch.slice(4) : '');
    if (dateTexte.value !== f) dateTexte.value = f;
    verifierDate(ch.length === 8);
  }
  function verifierDate(montrer) {
    var ch = dateTexte.value.replace(/\D/g, '');
    var ok = false;
    if (ch.length === 8) {
      var d = new Date(+ch.slice(4), +ch.slice(2, 4) - 1, +ch.slice(0, 2));
      var b = bornes();
      ok = d.getDate() === +ch.slice(0, 2) && d >= b[0] && d <= b[1];
      dateInput.value = ok ? iso(d) : '';
    } else {
      dateInput.value = '';
    }
    var erreur = ch.length > 0 && !ok && (montrer || ch.length === 8);
    if (erreur) { var bb = bornes(); dateErreur.textContent = T.dateErreur.replace('{min}', fr(bb[0])).replace('{max}', fr(bb[1])); }
    dateErreur.hidden = !erreur;
    if (erreur) dateTexte.setAttribute('aria-invalid', 'true'); else dateTexte.removeAttribute('aria-invalid');
    dateTexte.setAttribute('aria-describedby', dateErreur.id);
    majVisuel();
    return ch.length === 0 || ok;
  }
  function construireMode() {
    var rf = root.querySelector('recipient-form');
    if (!rf) return;
    if (modeBloc && document.contains(modeBloc)) return;
    var titre = el('p', 'sdo-ccad__etape', T.etape2);
    titre.style.marginTop = '22px';
    modeBloc = el('div', 'sdo-ccad-mode');
    modeBloc.setAttribute('role', 'group');
    modeBloc.setAttribute('aria-label', T.etape2);
    [['moi', T.modeMoi], ['offrir', T.modeOffrir]].forEach(function (m) {
      var b = el('button', 'sdo-ccad-mode__btn', m[1]);
      b.type = 'button';
      b.setAttribute('data-mode', m[0]);
      modeBloc.appendChild(b);
    });
    modeBloc.style.marginTop = '0';
    rf.parentNode.insertBefore(titre, rf);
    rf.parentNode.insertBefore(modeBloc, rf);
    modeBloc.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mode]');
      if (b) appliquerMode(b.getAttribute('data-mode'));
    });
    /* Date d'envoi programmée (propriété « Send on » reconnue par Shopify) */
    var champs = rf.querySelector('.recipient-fields');
    if (champs && !champs.querySelector('.sdo-ccad-date')) {
      var wrap = el('div', 'sdo-ccad-date');
      var id = 'sdo-ccad-date-' + Math.random().toString(36).slice(2, 7);
      var lab = el('label', '', T.dateLabel); lab.setAttribute('for', id);
      /* Champ texte jj/mm/aaaa (le sélecteur natif ne se laisse pas toujours saisir sur mobile),
         converti en AAAA-MM-JJ dans un champ caché, le seul envoyé. */
      dateTexte = el('input');
      dateTexte.type = 'text'; dateTexte.id = id; dateTexte.inputMode = 'numeric';
      dateTexte.autocomplete = 'off'; dateTexte.maxLength = 10; dateTexte.placeholder = T.datePlaceholder || 'jj/mm/aaaa';
      dateInput = el('input');
      dateInput.type = 'hidden'; dateInput.name = 'properties[Send on]';
      var aide = el('small', '', T.dateAide);
      dateErreur = el('small', 'sdo-ccad-date__erreur'); dateErreur.hidden = true;
      dateErreur.id = id + '-err'; dateErreur.setAttribute('role', 'alert');
      wrap.appendChild(lab); wrap.appendChild(dateTexte); wrap.appendChild(dateInput); wrap.appendChild(aide); wrap.appendChild(dateErreur);
      dateTexte.addEventListener('input', saisirDate);
      dateTexte.addEventListener('blur', function () { verifierDate(true); });
      champs.appendChild(wrap);
    }
    var cb = rf.querySelector('input[type="checkbox"]');
    appliquerMode(cb && cb.checked ? 'offrir' : mode, true);
  }
  function iso(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function appliquerMode(m, init) {
    mode = m;
    var rf = root.querySelector('recipient-form');
    var cb = rf && rf.querySelector('input[type="checkbox"]');
    if (cb && cb.checked !== (m === 'offrir')) {
      cb.checked = m === 'offrir';
      cb.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (modeBloc) [].forEach.call(modeBloc.querySelectorAll('[data-mode]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-mode') === m ? 'true' : 'false');
    });
    if (dateInput) dateInput.disabled = m !== 'offrir';
    if (dateTexte) dateTexte.disabled = m !== 'offrir';
    if (!init && m === 'offrir') {
      var e = champ('[name="properties[Recipient email]"]');
      if (e) setTimeout(function () { e.focus(); }, 50);
    }
    majVisuel();
  }

  /* ---------- Réassurance sous le bouton ---------- */
  function construireRassurance() {
    var bb = root.querySelector('.product-form__buy-buttons');
    if (!bb || root.querySelector('.sdo-ccad-rassure')) return;
    var ul = el('ul', 'sdo-ccad-rassure');
    (T.rassure || []).forEach(function (t) { ul.appendChild(el('li', '', t)); });
    bb.parentNode.insertBefore(ul, bb.nextSibling);
  }

  /* ---------- Écoute ---------- */
  root.addEventListener('input', function (e) {
    if (e.target.closest('recipient-form')) majVisuel();
  });
  root.addEventListener('change', function (e) {
    if (e.target.matches('variant-selects select')) { majMontants(); majVisuel(); }
  });
  /* Une date vide n'est pas envoyée (envoi immédiat). */
  document.addEventListener('submit', function (e) {
    if (!root.contains(e.target) || !dateInput) return;
    if (mode === 'offrir' && dateTexte && !verifierDate(true)) {
      e.preventDefault(); e.stopPropagation();
      dateTexte.focus();
      return;
    }
    dateInput.disabled = mode !== 'offrir' || !dateInput.value;
    setTimeout(function () { dateInput.disabled = mode !== 'offrir'; }, 0);
  }, true);

  /* ---------- Barre « Ajouter au panier » fixée par le thème sur mobile ----------
     Quand elle est affichée, la bulle Gorgias (et ses questions suggérées) remonte au-dessus. */
  var minuBarre = null;
  function barreFixe() {
    var b = root.querySelector('.product-form__button--fixed');
    var on = false, h = 0;
    if (b && getComputedStyle(b).display !== 'none') {
      var r = b.getBoundingClientRect();
      on = r.height > 0 && r.top < window.innerHeight - 4 && r.bottom > 0;
      h = Math.round(window.innerHeight - r.top);
    }
    document.body.classList.toggle('sdo-barre-on', on);
    if (on) document.body.style.setProperty('--sdo-barre-h', h + 'px'); else document.body.style.removeProperty('--sdo-barre-h');
  }
  ['scroll', 'resize'].forEach(function (ev) {
    window.addEventListener(ev, function () { if (minuBarre) return; minuBarre = requestAnimationFrame(function () { minuBarre = null; barreFixe(); }); }, { passive: true });
  });

  function tout() {
    barreFixe();
    construireVisuel();
    construireMontants();
    construireMode();
    construireRassurance();
    if (!dejaDefaut) {
      dejaDefaut = true;
      var s = select();
      if (s && !/[?&]variant=/.test(location.search) && s.selectedIndex === 0) {
        var cible = [].find.call(s.options, function (o) { return nombre(o.value) === 50; });
        if (cible) { autreOuvert = false; choisir(cible.value); }
      }
    }
  }
  var minu = null;
  new MutationObserver(function () { clearTimeout(minu); minu = setTimeout(tout, 60); })
    .observe(root, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
})();
